import MorningIntegration from './MorningIntegration';
export default MorningIntegration;
